import {kernel} from "./IOCHelper";
import * as Alt from "alt";
import {UserActionsImpl} from "../actions/UserActions";
import {Symbols} from "./Symbols";
import {UserStore} from "../store/UserStore";


export let altInstance = new Alt();

export class AppCtx {
    static resolve<T>(name: string) {
        var dep: T = kernel.get<T>(name);
        if (dep == null) {
            console.error("Unable to resolve dependency ", name);
        }
        return dep;
    }

    static getUserActions() {
        return AppCtx.resolve<UserActionsImpl>(Symbols.UserActions);
    }

    static getAlt(): any {
        return altInstance;
    }

    static getUserStore(): AltJS.AltStore<UserStore> {
        return AppCtx.resolve<AltJS.AltStore<UserStore>>(Symbols.UserStore);
    }
}


export function inject(name?: string) {
    return (target: Object, propertyKey: string) => {
        if (!name) {
            name = propertyKey;
        }
        var injectable = kernel.get<any>(name);
        if (!injectable) {
            console.warn("Unable to inject " + name + " for property " + propertyKey + " in:", target);
        }
        target[propertyKey] = injectable;
    };
}



// WEBPACK FOOTER //
// ./src/app/ioc/ApplicationContext.ts